module.exports = __webpack_public_path__ + "img/shape-home-desktop.636b87ba81e8864be5b3b1531e316cac.svg";